export const FRESHCHAT_HOST = 'https://wchat.freshchat.com';
export const FRESHCHAT_WIDGET_PATH = 'js/widget.js';
export const FRESHCHAT_WIDGET_URL = `${FRESHCHAT_HOST}/${FRESHCHAT_WIDGET_PATH}`;

export const FRESHCHAT_WIDGET_CLASS = 'mt-fc_frame';

export const LOGGER_NAME = 'freshchat';

export const FRESHCHAT_WIDGET_ID_FOR_UX_REFRESH = '1307ceb3-c65e-4946-8eb3-31604b282314';

export const FRESHCHAT_EVENT_NAME = {
  WIDGET_USER_CREATED: 'user:created',
  WIDGET_CLOSED: 'widget:closed',
  WIDGET_CSAT_RECEIVED: 'csat:received',
  WIDGET_CSAT_UPDATED: 'csat:updated',
  WIDGET_LOADED: 'widget:loaded',
  WIDGET_CONVERSATION_RESOLVED: 'conversation:resolved',
  WIDGET_MESSAGE_SENT: 'message:sent',
  WIDGET_MESSAGE_RECEIVED: 'message:received',
};

export const MESSAGES = {
  CSAT_REPLY_PLACEHOLDER: 'Type here...',
  CSAT_QUESTION: 'Were you satisfied with our help?',
  REPLY_FIELD_PLACEHOLDER: 'Pro tip: detailed prompts unlock my full potential to help you.',
};
